import React from 'react';

const HelpUtilityContext = React.createContext();

export const HelpUtilityProvider = HelpUtilityContext.Provider;

export default HelpUtilityContext;
